import { useTeam } from '@vrplatform/data';
export const useHasReservationUserDataEditAccess = () => {
  const [{ id: teamId }] = useTeam();

  return ['5599d7c0-a692-423c-9e06-3fac8d63048d'].includes(teamId);
};
